export const selectStyles = (error = false) => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 1070,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: 'rgba(var(--cui-body-bg-rgb), 0.8)',
    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
    '::-webkit-scrollbar': {
      width: '10px',
      opacity: '0',
    },
    '::-webkit-scrollbar-thumb': {
      borderRadius: '50px',
      background: 'var(--cui-gray-500)',
    },
    '::-webkit-scrollbar-track': {
      borderRadius: '50px',
    },
    '::hover::-webkit-scrollbar': {
      display: 'block',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: 'var(--cui-gray-700)',
    },
  }),
  control: (base, state) => ({
    ...base,
    height: '35px',
    minHeight: '35px',
    width: '100%',
    backgroundColor: state.isDisabled
      ? 'rgba(var(--cui-gray-300-rgb), 0.2)'
      : 'rgba(255, 255, 255, 0.05)',
    borderColor: state.isFocused
      ? 'rgba(var(--cui-gray-800-rgb), 0.4)'
      : !error
      ? 'rgba(var(--cui-gray-800-rgb), 0.4)'
      : 'var(--cui-danger)',
    borderRadius: '0.25rem',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(38, 143, 255, 0.25)' : 'none',
    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    '&:hover': {
      borderColor: state.isFocused ? '' : !error ? '' : 'var(--cui-danger)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    paddingBottom: '0.3rem',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--cui-body-color)',
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? 'var(--cui-white)'
      : state.isFocused
      ? 'var(--cui-white)'
      : 'var(--cui-body-color)',
    backgroundColor: state.isSelected
      ? 'var(--cui-blue)'
      : state.isFocused
      ? 'var(--cui-blue)'
      : 'none',
    '&:hover': {
      color: 'var(--cui-white)',
      backgroundColor: 'var(--cui-blue)',
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'rgba(var(--cui-gray-800-rgb), 0.6)',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'rgba(var(--cui-gray-800-rgb), 0.4)',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'rgba(var(--cui-gray-800-rgb), 0.8)',
    color: 'rgba(var(--cui-body-bg-rgb), 0.7)',
    borderRadius: '0.25rem',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--cui-white)',
  }),
})
